/**
 * Created by Jie Gao on 3/6/2019.
 */

import {Currency} from "@nolimitcity/slot-game/bin/core/balance/Currency";
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {IBetWayWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {BitmapTextStyleOptions} from "@nolimitcity/slot-game/bin/core/text/BitmapTextStyleOptions";
import {MathHelper} from "@nolimitcity/slot-game/bin/core/utils/MathHelper";
import {TimelineLite, TweenLite} from "gsap";
import {TweenParticleEmitter} from "../../coinfountain/TweenParticleEmitter";
import {DragonTribeGameConfig} from "../../DragonTribeGameConfig";

export class DragonTribeInitialWPView extends BaseView {
    private readonly _winNumberStyle:any = {
        fontName : "NumbersWinCountUp",
        fontSize : 5,
        tint : parseInt(("#ffffff").replace(/^#/, ''), 16)
    };
    private readonly _winNumberTotalDuration:number = 2;
    private readonly _winNumberFadeOutDuration:number = 1.3;
    private readonly _winNumberOffsetY:number = -100;
    private readonly _winNumberInterval:number = 0.2;
    private readonly _maxWinNumberWidth:number = GameConfig.instance.SYMBOL_WIDTH;
    private _coinParticles:TweenParticleEmitter;
    private _layer:ScalableLayer;

    constructor() {
        super();
        this._layer = StageManager.getLayer(DragonTribeGameConfig.instance.LAYERS.WIN_PRESENTATIONS.name);
    }

    protected initAnimations():void {
        this._coinParticles = new TweenParticleEmitter(GameResources.getTextures("bigWinCoin0"));
        this._layer.addChild(this._coinParticles)
    }

    public playBlueGems(level:number):void {
        this._coinParticles.maxParticles = ((level === 0) ? 20 : 30);
        this._coinParticles.getAnimation();
    }

    public playWinNumbers(betWayWinData:IBetWayWinData, startPosition:[number, number]):TimelineLite {
        let text:string = Currency.formatValue(MathHelper.roundToDecimals(betWayWinData.amount, 2));
        if(betWayWinData.multiplier > 1) {
            text += ` x ${betWayWinData.multiplier}`;
        }

        const timeline:TimelineLite = new TimelineLite({paused : true});
        timeline.add(() => this.playWinNumberAnimation(text, startPosition), this._winNumberInterval);

        return timeline;
    }

    // do not abort this ever, like wixx.
    private playWinNumberAnimation(text:string, startPosition:[number, number]):void {
        // Logger.logDev(`win number position = [${startPosition[0]}, ${startPosition[1]}]`);
        const winNumber:PIXI.BitmapText = new PIXI.BitmapText(text, this._winNumberStyle);
        (<PIXI.Point>winNumber.anchor).set(0.5, 0.5);
        winNumber.position.set(startPosition[0], startPosition[1]);
        this._layer.addChild(winNumber);
        winNumber.updateTransform();
        if(winNumber.width > this._maxWinNumberWidth) {
            const scale:number = MathHelper.roundToDecimals(this._maxWinNumberWidth / winNumber.width, 2);
            winNumber.scale.set(scale);
        }
        const timeline:TimelineLite = new TimelineLite();
        timeline.add(TweenLite.to(winNumber, this._winNumberTotalDuration, {y : startPosition[1] + this._winNumberOffsetY}), 0.2);
        timeline.add(TweenLite.to(winNumber, this._winNumberFadeOutDuration, {alpha : 0}), `-=${this._winNumberFadeOutDuration}`);
        timeline.add(() => {
            this._layer.removeChild(winNumber);
            winNumber.destroy();
        });
    }

    protected onResize(resizeData:IResizeData):void {
        this._coinParticles.y = Math.round((resizeData.height - this._layer.y) / this._layer.scale.y) + 40;
        this._coinParticles.x = 640;
        this._coinParticles.orientation = resizeData.orientation;
    }
}